// src/cache/liveVisitorsRing.cache.ts

import { getRedisClient } from "../../client";
import { getKey } from "../../utils/redisKeys";

const prefix = "live-ring";

const getCurrentBucket = (): number => {
  const nowInMinutes = Math.floor(Date.now() / 1000 / 60);
  return nowInMinutes % 5;
};

export const liveVisitorsRingCache = {
  async ping(siteId: string, userId: string): Promise<void> {
    const client = getRedisClient();
    const bucket = getCurrentBucket();
    const key = getKey({ prefix, namespace: siteId, id: bucket });
    await client.sAdd(key, userId);
    await client.expire(key, 60); // 5 minutes
  },

  async getActiveVisitors(siteId: string): Promise<number> {
    const client = getRedisClient();
    const bucketKeys: string[] = [];

    for (let i = 0; i < 5; i++) {
      const key = getKey({ prefix, namespace: siteId, id: i });
      bucketKeys.push(key);
    }

    const uniqueUsers = await client.sUnion(bucketKeys);
    return uniqueUsers.length;
  },

  async reset(siteId: string): Promise<void> {
    const client = getRedisClient();
    const keys = [];

    for (let i = 0; i < 5; i++) {
      keys.push(getKey({ prefix, namespace: siteId, id: i }));
    }

    if (keys.length > 0) {
      await client.del(keys);
    }
  }
};